import { render, staticRenderFns } from "./BullettinByBookModal.vue?vue&type=template&id=b7410572&"
import script from "./BullettinByBookModal.vue?vue&type=script&lang=js&"
export * from "./BullettinByBookModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports